import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const paymentMethods = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/payment-methods', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  return {list}
}
